module.exports = __webpack_public_path__ + "img/chitarra-aperitivo.a7701ab1.jpg";